/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{c as r}from"../../chunks/vec32.js";import{getProjector as t,projectorCache as o,copy3 as n}from"./projectors.js";function e(e,c,f,s,u,i,l=1){const m=t(c,u,o);if(null==m)return!1;if(m===n){if(e===s&&f===i)return!0;const t=f+l;for(let o=f,n=i;o<t;++o,++n)r(s[n],e[o]);return!0}const p=f+l;for(let r=f,t=i;r<p;++r,++t)m(e[r],0,s[t],0);return!0}export{e as projectVec3Array};
